import { FPG_PLANS } from '../../constants.js';
import { StandardPricing } from './pricing/standard.jsx';
import { AdvancedPricing } from './pricing/advanced.jsx';

export const RiskFactor = ({ plan }) => {
  if (plan === FPG_PLANS.standard) return <StandardPricing />;
  if (plan === FPG_PLANS.advanced) return <AdvancedPricing />;
  return null;
};
